// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"168":"9c307b08","554":"b6e4209f","831":"d0b4841d"}[chunkId] + ".css";
};